import { putOrg } from '@/api'
import empty from '@/asset/img/empty.webp'
import Text from '@/components/Text'
import { grayText, primary, secondaryText } from '@/constant'
import { usePermission } from '@/hooks'
import { DragArrow, ImageIcon } from '@/icon'
import { ApplicationInfo } from '@/types'
import KeyboardBackspaceIcon from '@mui/icons-material/KeyboardBackspace'
import { Skeleton } from '@mui/material'
import { arrayMoveImmutable } from 'array-move'
import React, { useCallback, useEffect, useMemo, useState } from 'react'
import { SortableContainer, SortableElement, SortableHandle } from 'react-sortable-hoc'
import {
  CardContent,
  CardHoverArea,
  ContentFooter,
  InfoWrapper,
  MyProductRow,
  ProductCard,
  ProductsIcon,
} from './index'

const DragHandle = SortableHandle(() => <DragArrow className="drag_handle" />)

// @ts-ignore
const SortableItem = SortableElement<{ item, handleEnterApp, showDrag: boolean }>(({ item, handleEnterApp, showDrag }) => (
  <CardHoverArea key={item.id}>
    <ProductCard className="product-card" sx={{ position: 'relative', cursor: 'pointer' }}>
      {showDrag ? <DragHandle /> : null}
      {/* <DragIndicatorIcon color="primary" sx={{ position: "absolute", right: "0", top: "0", cursor: "move"  }} /> */}
      <CardContent
        className="card-content"
        // @ts-ignore
        sx={{
          backgroundImage: `url(${item.screenshots[0]})`,
          backgroundSize: '100% 141px',
          backgroundRepeat: 'no-repeat',
          backgroundPosition: 'top left',
          boxShadow: '0px 4px 10px 0px rgba(145,158,171,0.1)',
          width: '224px',
          height: '188px',
          gap: '24px',
          justifyContent: 'space-between',
          filter: item?.status === 0 && 'grayscale(100)',
          flexDirection: 'column-reverse',
        }}
        onClick={handleEnterApp(item)}
      >
        <ContentFooter
          className="content-footer"
          sx={{ width: '100%', position: 'relative', justifyContent: 'space-between', cursor: item?.status === 0 ? 'not-allowed' : 'pointer' }}
        >
          <KeyboardBackspaceIcon
            className="content-footer-arrow-left"
            sx={{
              transform: 'rotate(180deg)',
              color: primary,
            }}
          />
          <ImageIcon
            src={item.logo_url}
            className="content-footer-text"
            sx={{
              width: '16px',
              aspectRatio: '1',
              borderRadius: '4px',
              overflow: 'hidden',
              mr: '8px'
            }}
          />
          <Text
            className="content-footer-text"
            size="xs"
            sx={{ color: secondaryText, fontSize: '14px' }}
          >
            {item.name}
          </Text>
          <Text
            className="content-footer-button"
            size="xs"
            sx={{
              color: primary,
              position: 'absolute',
              left: '50%',
              minWidth: '60px',
            }}
          >
            立即使用
          </Text>
          <KeyboardBackspaceIcon
            className="content-footer-arrow-right"
            sx={{
              transform: 'rotate(180deg)',
              color: primary,
              marginLeft: 'auto',
            }}
          />
        </ContentFooter>
      </CardContent>
    </ProductCard>
  </CardHoverArea>
))

// @ts-ignore
const SortableList = SortableContainer<{ items, handleEnterApp, showDrag: boolean }>(({ items, handleEnterApp, showDrag }) => {
  return (
    <MyProductRow sx={{ pl: '6px', justifyContent: items.length > 3 ? 'space-evenly' : 'flex-start' }}>
      {
        // @ts-ignore
        items?.map((item, index) => <SortableItem showDrag={showDrag} handleEnterApp={handleEnterApp} key={item.id} index={index} item={item} />)
      }
    </MyProductRow>
  )
})
export interface productsProps {
  products: ApplicationInfo[];
  loading: boolean;
  org_id: number
  enterApp: (app: ApplicationInfo) => void;
}

const Products: React.FC<productsProps> = (props) => {
  const { org_id, products, loading, enterApp } = props


  const perms = usePermission()

  const [data, setData] = useState<ApplicationInfo[]>(products)
  const showDrag = useMemo(() => {
    return perms.includes('admin')
  }, [perms])
  useEffect(() => {
    setData(products)
  }, [products])
// @ts-ignore
  const onSortEnd = ({ oldIndex, newIndex }) => {
    setData((items) =>
      arrayMoveImmutable(items, oldIndex, newIndex),
    )
    putOrg({ id: org_id, app_id: products[oldIndex]?.id, app_old_index: oldIndex, app_new_index: newIndex })
  }

  const handleEnterApp = useCallback(
    (app: ApplicationInfo) => () => {
      if (app?.status !== 0) {
        enterApp(app)
      }
    },
    [enterApp]
  )
  return (
    <InfoWrapper
      sx={{
        padding: '30px 14px 14px 14px',
        flexDirection: 'column',
        gap: '24px',
        overflow: 'visible',
      }}
    >
      <Text
        weight="bold"
        size="xs"
        sx={{
          display: 'flex',
          alignItems: 'center',
          gridColumn: '1/-1',
          fontSize: '14px',
          height: '10px',
        }}
      >
        <ProductsIcon />
        我的产品
      </Text>
      {!loading ? (
        data?.length > 0 ? (
          <SortableList axis='xy' showDrag={showDrag} handleEnterApp={handleEnterApp} items={data} onSortEnd={onSortEnd} useDragHandle />
        ) : (
          <Text
            size="xs"
            sx={{
              display: 'flex',
              alignItems: 'center',
              gap: '8px',
              flexDirection: 'column',
              color: grayText,
              margin: 'auto',
            }}
            weight="regular"
          >
            <ImageIcon src={empty} sx={{ width: '48px' }} />
            暂未开通产品
          </Text>
        )
      ) : (
        <MyProductRow>
          {[1, 2, 3].map((item) => (
            <ProductCard key={item}>
              <CardContent
                sx={{
                  backgroundColor: '#eee',
                  width: '224px',
                  gap: '24px',
                  justifyContent: 'space-between',
                }}
              >
                <Text
                  size="xs"
                  sx={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: '8px',
                  }}
                >
                  <ImageIcon
                    src=""
                    sx={{
                      width: '40px',
                      aspectRatio: '1',
                      backgroundColor: '#ddd',
                    }}
                  />
                  <Skeleton width={120} height={20} />
                </Text>
                <ContentFooter>
                  <Skeleton width={120} height={20} />
                </ContentFooter>
              </CardContent>
            </ProductCard>
          ))}
        </MyProductRow>
      )}
    </InfoWrapper>
  )
}

export default Products
